export default {
  "main": {
    "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف"])},
    "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["القيمة"])},
    "lang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اللغة"])},
    "ar": {
      "key": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ar"])},
      "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العربية"])}
    },
    "fr": {
      "key": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fr"])},
      "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الفرنسية"])}
    },
    "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
  },
  "messages": {
    "dayTransLimit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لقد وصلت إلى الحد الأقصى من المعاملات  في اليوم "])},
    "monthTransLimit": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["لقد وصلت إلى الحد الأقصى من المعاملات  في الشهر ", _interpolate(_named("limit"))])},
    "dayAmountLimit": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["عذرًا ، لقد تجاوزت الحد الأقصى اليومي البالغ ", _interpolate(_named("limit")), " "])},
    "monthAmountLimit": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["عذرًا ، لقد تجاوزت الحد الأقصى الشهري لـ ", _interpolate(_named("limit")), " "])},
    "invalidPhone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف غير موجود"])},
    "minAmount": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["اقل قيمة هي ", _interpolate(_named("limit"))])}
  }
}